import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import "./App.css";

import Header from "./components/Header/Header"; // Header clásico
import HeaderAcces from "./components/HeaderAcces/HeaderAcces"; // Header para welcome y páginas logueadas
import Footer from "./components/Footer/Footer";

import Home from "./components/Home/Home";
import Conocenos from "./components/Conocenos/Conocenos";
import Login from "./components/Login/Login";
import Registrarme from "./components/Registrarme/Registrarme";
import Welcome from "./components/Welcome/Welcome";
import ResetPassword from "./components/ResetPassword/ResetPassword";

import CrearGrupo from "./components/CrearGrupo/CrearGrupo";
import ListGrupos from "./components/ListGrupos/ListGrupos";
import GroupDetail from "./modules/groups/GroupDetail/GroupDetail";

// Layout que maneja qué header mostrar según ruta
const Layout = ({ children }) => {
  const location = useLocation();

  // Rutas sin header pero con footer
  const noHeaderRoutes = ["/login", "/registrarme", "/reset-password"];

  // Rutas con header acces (logueado)
  const headerAccesRoutes = [
    "/welcome",
    "/create-group",
    "/list-group",
    "/groups",
  ];

  if (noHeaderRoutes.includes(location.pathname)) {
    // Sin header, solo footer
    return (
      <>
        {children}
        <Footer />
      </>
    );
  } else if (headerAccesRoutes.includes(location.pathname)) {
    // HeaderAcces + footer
    return (
      <>
        <HeaderAcces />
        {children}
        <Footer />
      </>
    );
  } else {
    // Header clásico + footer para Home, Conocenos, etc.
    return (
      <>
        <Header />
        {children}
        <Footer />
      </>
    );
  }
};

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/conocenos" element={<Conocenos />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registrarme" element={<Registrarme />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/create-group" element={<CrearGrupo />} />
          <Route path="/list-group" element={<ListGrupos />} />

          {/* Ruta para el detalle del grupo (visita normal) */}
          <Route
            path="/groups/:hashedId/detalle"
            element={<GroupDetail type="view" />}
          />

          {/* Ruta para la administración/edición del grupo (solo dueños) */}
          <Route
            path="/groups/:hashedId/admin"
            element={<GroupDetail type="admin" />}
          />

          {/* agrega más rutas aquí si necesitas */}
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
